import { Box, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// import FullLogo from "../../theme/icons/FullLogo";
import { ReactComponent as FullLogo } from "../../static/svg/full-logo.svg";
import { ReactComponent as Facebook } from "../../static/svg/socials/facebook.svg";
import { ReactComponent as Instagram } from "../../static/svg/socials/instagram.svg";
import { ReactComponent as HomeIcon } from "../../static/svg/home.svg";
import { ReactComponent as PhoneIcon } from "../../static/svg/phone.svg";
import { navHelp, navOthers } from "../../utils/testData";

export const Footer = () => {
  return (
    <Fragment>
      <footer className=" bg-black-900 text-white px-4 md:px-6 ">
        <div className="lg:flex lg:gap-12 pt-10 items-center">
          <div className="mb-6 md:mb-6 lg:mb-0 ">
            <Link
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
              to={"/"}
              className=" flex items-center justify-center lg:justify-start"
            >
              <FullLogo
                // className=" text-2xl"
                width="20rem"
                height="20rem"
                style={{
                  marginTop: "-50px",
                  marginBottom: "-50px",
                }}
              />

              {/* <Typography
                variant="h3"
                // fontWeight={900}
                fontSize={{ xs: "40px", sm: "55px", md: "px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.05em"}
                color="white"
                className=" uppercase"
              >
                Salvation Parish
              </Typography> */}
              <br />
            </Link>
            <div className="flex space-x-2 md:justify-start justify-center">
              {/* <a
                href="https://www.facebook.com/strandzbydee/"
                target="_blanc"
                className="text-white hover:text-blue-400 "
              >
                <Facebook />
              </a> */}
              <a
                href="https://www.instagram.com/strandzbydee/"
                target="_blanc"
                className="text-white hover:text-red-400 "
              >
                <Instagram />
              </a>
            </div>
          </div>
          <div className="grid grid-cols-12 lg:gap-20 ">
            <div className=" space-y-3 block col-span-12 md:col-span-8 lg:col-start-2 lg:col-span-7 justify-center md:justify-start md:text-start text-center mb-4">
              <Typography
                variant="caption"
                fontWeight={300}
                fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
                //   lineHeight={{ xs: "103%", sm: "155.5%" }}
                letterSpacing={"-0.05em"}
                color="white"
                className="opacity-75 grid"
              >
                Shop With Us Today!
              </Typography>

              <Box className=" flex gap-1 !mx-auto place-content-center md:place-content-start items-center">
                <HomeIcon color="#D3AC2B" className=" !h-5 !w-5 " />
                <Typography
                  variant="body"
                  fontWeight={300}
                  fontSize={{ xs: "16px", sm: "16px", md: "16px" }}
                  //   lineHeight={{ xs: "103%", sm: "155.5%" }}
                  letterSpacing={"-0.05em"}
                  color="white"
                  className=" md:pl-2"
                >
                  193b London Road CR0 2RJ
                </Typography>
              </Box>
              <Box className=" flex !mx-auto place-content-center md:place-content-start items-center">
                <PhoneIcon color="#D3AC2B" className=" !h-5 !w-5" />
                <Typography
                  variant="subtitle"
                  fontWeight={300}
                  fontSize={{ xs: "15px", sm: "15px", md: "15px" }}
                  //   lineHeight={{ xs: "103%", sm: "155.5%" }}
                  letterSpacing={"-0.05em"}
                  color="white"
                  className="md:pl-2 mx-auto"
                >
                  +447 936 794742 (Whatsapp | SMS)
                </Typography>
              </Box>
            </div>
            <div className="col-span-6 md:col-span-2 mx-auto">
              <Box className=" mb-4">
                <Typography
                  variant="caption"
                  fontWeight={600}
                  fontSize={{ xs: "15px", sm: "15px", md: "15px" }}
                  lineHeight={{ xs: "103%", sm: "155.5%" }}
                  letterSpacing={"-0.05em"}
                  color="white"
                  className="underline "
                >
                  Help
                </Typography>
              </Box>
              <ul className="">
                {navHelp.map((item, index) => (
                  <li key={index}>
                    <Link
                      className="hover-underline-animation"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "smooth",
                        });
                      }}
                      to={item.path}
                    >
                      <Typography
                        variant="subtitle"
                        fontWeight={600}
                        fontSize={{ xs: "14px", sm: "14px", md: "14px" }}
                        lineHeight={{ xs: "103%", sm: "155.5%" }}
                        letterSpacing={"-0.05em"}
                        color="white"
                        className=" lg:opacity-75 hover:opacity-100"
                      >
                        {item.name}
                      </Typography>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-6 md:col-span-2 mx-auto font-aref">
              <Box className=" mb-4">
                <Typography
                  variant="caption"
                  fontWeight={600}
                  fontSize={{ xs: "15px", sm: "15px", md: "15px" }}
                  lineHeight={{ xs: "103%", sm: "155.5%" }}
                  letterSpacing={"-0.05em"}
                  color="white"
                  className="underline "
                >
                  Other
                </Typography>
              </Box>

              <ul className="">
                {navOthers.map((item, index) => (
                  <li key={index}>
                    <Link
                      className="hover-underline-animation"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "smooth",
                        });
                      }}
                      to={item.path}
                    >
                      <Typography
                        variant="subtitle"
                        fontWeight={600}
                        fontSize={{ xs: "14px", sm: "14px", md: "14px" }}
                        lineHeight={{ xs: "103%", sm: "155.5%" }}
                        letterSpacing={"-0.05em"}
                        color="white"
                        className="  lg:opacity-75 hover:opacity-100"
                      >
                        {item.name}
                      </Typography>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        {/* <hr className="my-6 border-gray-200 sm:mx-auto  lg:my-8 " /> */}
        <div className="flex items-center justify-center py-12 lg:px-4">
          <span className="text-sm text-white sm:text-center ">
            © 2024
            <a
              href="https://cyberbracetech.com/"
              target="_blanc"
              className="ml-2 pr-1 hover:underline text-white hover:text-custom"
            >
              CyberBrace™ |
            </a>
            All Rights Reserved
          </span>
        </div>
      </footer>
    </Fragment>
  );
};
